<template>
  <section class="work section">
    <div class="section-center">
      <div class="section-center">
        <h2 class="section__title text-title link-title">
          <span data-aos="zoom-in">Latest Works.</span>
        </h2>
      </div>
    </div>
    <span class="section__subtitle" data-aos="fade-up"
      >Explore some of my projects.</span
    >
    <div data-aos="fade-up" class="work__container container grid">
      <div
        data-aos="zoom-in"
        v-for="(projet, index) in projets.slice(0, 10)"
        :key="index"
        class="work__card"
        @click="openModal(projet)"
      >
        <img :src="projet.img" :alt="projet.title" class="work__img" />
        <div class="details__projets">
          <h3 class="work__title">{{ projet.title }}</h3>
        </div>
        <p class="description__project">
          {{ projet.description }}
          <span class="underline">
            <span>View</span
            ><svg viewBox="0 0 13 20">
              <polyline points="0.5 19.5 3 19.5 12.5 10 3 0.5" />
            </svg>
          </span>
        </p>
      </div>
    </div>
    <div class="button__plus"></div>

    <!-- MODAL -->
    <transition name="modal-fade">
      <div v-if="showModal" class="modal-overlay" @click="closeModal">
        <div class="modal-container" @click.stop>
          <button class="modal-close" @click="closeModal">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
              />
            </svg>
          </button>

          <!-- HEADER FIXE -->
          <div class="modal-header">
            <h2 class="modal-title">{{ selectedProjet.title }}</h2>
          </div>

          <!-- CONTENU SCROLLABLE -->
          <div class="modal-content">
            <div class="modal-description">
              <p>{{ selectedProjet.description }}</p>
            </div>

            <div
              v-if="selectedProjet.images && selectedProjet.images.length"
              class="modal-gallery"
            >
              <div
                v-for="(image, idx) in selectedProjet.images"
                :key="idx"
                class="modal-gallery-item"
              >
                <img
                  :src="image"
                  :alt="`${selectedProjet.title} - Image ${idx + 1}`"
                />
              </div>
            </div>
          </div>

          <!-- FOOTER FIXE -->
          <div class="modal-footer">
            <a
              v-if="selectedProjet.link"
              :href="selectedProjet.link"
              target="_blank"
              rel="noopener noreferrer"
              class="button modal-link"
            >
              Visit Project →
            </a>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      showModal: false,
      selectedProjet: {},
    };
  },
  methods: {
    openModal(projet) {
      this.selectedProjet = projet;
      this.showModal = true;
      document.body.style.overflow = "hidden";
    },
    closeModal() {
      this.showModal = false;
      document.body.style.overflow = "";
    },
  },
  computed: {
    ...mapGetters(["projets"]),
  },
  beforeUnmount() {
    document.body.style.overflow = "";
  },
};
</script>

<style scoped>
@import url("../assets/css/projet.css");

/* MODAL STYLES */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
  overflow: hidden;
}

.modal-container {
  background: #fff;
  border-radius: 16px;
  max-width: 1500px;
  width: 100%;
  max-height: 95vh;
  position: relative;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  animation: modalSlideUp 0.3s ease-out;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

@keyframes modalSlideUp {
  from {
    opacity: 0;
    transform: translateY(50px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-close {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  border: none;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10;
}

.modal-close:hover {
  background: rgba(0, 0, 0, 0.2);
  transform: rotate(90deg);
}

.modal-close svg {
  fill: #333;
}

/* HEADER FIXE */
.modal-header {
  padding: 40px 40px 20px;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
}

.modal-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.2;
  margin: 0;
  padding-right: 50px;
}

/* CONTENU SCROLLABLE */
.modal-content {
  padding: 20px 30px;
  overflow-y: auto;
  flex: 1;
  scrollbar-width: thin;
  scrollbar-color: #ddd transparent;
}

.modal-content::-webkit-scrollbar {
  width: 8px;
}

.modal-content::-webkit-scrollbar-track {
  background: transparent;
}

.modal-content::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 4px;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}

.modal-description {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
  margin-bottom: 30px;
}

.modal-gallery {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}

.modal-gallery-item {
  border-radius: 12px;
  overflow: hidden;
  /* background: #f5f5f5; */
  width: 100%;
  border: 1px solid #f5f5f5;
  padding: 8px;
}

.modal-gallery-item img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.3s ease;
}

/* FOOTER FIXE */
.modal-footer {
  padding: 20px 40px;
  border-top: 1px solid #eee;
  flex-shrink: 0;
  background: #fff;
}

.modal-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 28px;
  /* background: #1a1a1a; */
  /* color: #fff; */
  text-decoration: none;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.modal-link:hover {
  /* background: #333; */
  transform: translateX(5px);
}

/* TRANSITIONS */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

/* RESPONSIVE */
@media screen and (max-width: 1024px) {
  .modal-container {
    max-width: 800px;
  }

  .modal-title {
    font-size: 1rem;
  }
}

@media screen and (max-width: 768px) {
  .modal-container {
    border-radius: 15px;
    max-height: 95vh;
  }

  .modal-header {
    padding: 30px 25px 15px;
  }

  .modal-content {
    padding: 10px 15px;
  }

  .modal-footer {
    padding: 15px;
  }

  .modal-title {
    font-size: 1.2rem;
    padding-right: 20px;
  }

  .modal-description {
    font-size: 1rem;
  }

  .modal-gallery {
    gap: 15px;
  }
}
</style>
